import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { DragulaService } from 'ng2-dragula/ng2-dragula';

import { Lecture } from '../../lectures/shared/lecture';
import { LectureLessonService } from '../../lectures/shared/lecture-lesson.service';
import { ListComponentBase } from '../../shared/base/list-component-base';
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Lesson } from '../shared/lesson';

@Component({
  selector: 'app-lesson-list',
  templateUrl: './lesson-list.component.html',
  viewProviders: [DragulaService]
})
export class LessonListComponent extends ListComponentBase implements OnInit, OnDestroy {
  @Input() lessons: Lesson[];
  @Input() lecture: Lecture;

  constructor(snackBar: MatSnackBar, dragulaService: DragulaService, private refService: LectureLessonService) {
    super(snackBar, dragulaService);
  }

  ngOnInit() {
    this._initSubscriptions();

    this.dragulaService.setOptions(this.bagName, {
      accepts: (el: Element, target: Element, source: Element, sibling: Element): boolean => {
        return !el.contains(target);
      },
      moves: (el: Element, container: Element, handle: Element): boolean => {
        return el.tagName.toLowerCase() === 'div';
      }
    });
  }

  ngOnDestroy() {
    this._dropSubscriptions();
  }

  get bagName(): string {
    return this.lecture.$key;
  }

  async onSubmit() {
    try {
      await this.refService.readChildAsObject(this.lecture.$key).$ref.transaction(lecture => {
        this.lessons.map((lesson, index) => lecture[lesson.$key].order = index);
        return lecture;
      });
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-list/lesson-list.component.ts